const queryStringParams = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
class DyeforCollectionColorbox extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    setTimeout(() => {
      this.init();
    });
  }
  findBrandlinks(){
    if(this.classList.contains('brandlinks')){
      var parser = document.createElement('a');
      parser.href = window.location.href;
      let pathParts = parser.pathname.split('/').filter(p=> p.length>0);
      if(pathParts[0].toLocaleLowerCase() !== "collections"){
        return;
      }

      if(this.querySelector('a.selected')){
        return;
      }
      
      let foundButton  = null;
      this.querySelectorAll('a').forEach(e=>{
        let textToSearch = e.innerHTML.toLocaleLowerCase();
        if(foundButton === null && pathParts[1].includes(textToSearch)){
          foundButton = e;
          e.classList.add('selected');
        }
      });
    }
  }
  init(){
    this.findBrandlinks();
    if(this.querySelectorAll('.hc-color-box-inner').length > 0 && this.querySelector('.hc-color-box-inner').scrollWidth > this.offsetWidth) {
      let arrowClick = function(e) {
        if (e.target.classList.contains('icon-left-arrow')) {
          let cur_pos = this.querySelector('.hc-color-box-inner').scrollLeft;
          this.querySelector('.hc-color-box-inner').scroll({ left: cur_pos - 200})
        }
        if (e.target.classList.contains('icon-right-arrow')) {
          let cur_pos = this.querySelector('.hc-color-box-inner').scrollLeft;
          this.querySelector('.hc-color-box-inner').scroll({ left: cur_pos + 200 })
        }
      }
      if(this.querySelector('.hc-color-box-inner')){
        this.querySelector('.hc-color-box-inner').classList.remove('center');
      }
      this.querySelectorAll('.collection-btn-group').forEach(function(i){
        i.classList.remove('hidden');
      });      
      Array.from(this.querySelectorAll('.collection-btn-group')).forEach(i=> {
        i.addEventListener('click', arrowClick.bind(this))
      });
    }
  }

}
window.customElements.define('dyefor-collection-colorbox', DyeforCollectionColorbox);
class DyeforCollectionBreadcrumb extends HTMLElement{
  constructor(){
    super()
  }
}
window.customElements.define('dyefor-collection-breadcrumb', DyeforCollectionBreadcrumb);


class DyeforCollectionFilter extends HTMLElement{
  constructor(){
    super();
  }
  _dataLoaded = false;
  _filterData = [];
  selectedTags = (currentTags||[]).map(i=> i.toLowerCase().replaceAll(' ', '-').replaceAll("'", '').replaceAll('&#39;', ''));
  connectedCallback(){
    this.querySelector('.clear-sort').addEventListener('click', (event)=>{
      event.preventDefault();
      window.location = removeParam(window.location.href, 'sort_by');
    });
    this.querySelector('.open-left-draw').addEventListener('click', (event)=>{
      event.preventDefault();
      this.openLeft();
    });
    this.querySelector('.open-right-draw').addEventListener('click', (event)=>{
      event.preventDefault();
      this.openRight();
    });
    for(const link of this.querySelectorAll(".closebtn")){
      link.addEventListener('click', (e)=>{
        e.preventDefault();
        this.closeAll();
      });
    }
    this.querySelector('.drawer-overlay').addEventListener('click', (e)=> {
      e.preventDefault();
      this.closeAll();
    });

    this.querySelector('.remove-sort-wrapper').display = "none";
    for(const btn of this.querySelectorAll('.sortby-collection button')){
      if(queryStringParams.sort_by){
        if(queryStringParams.sort_by === btn.getAttribute('data-perm')){
          btn.classList.add('active');
          this.querySelector('.remove-sort-wrapper').display = "block";
          this.querySelector('button.open-left-draw .sort-count').innerHTML = "(1)";
        }  
      }
      btn.addEventListener('click', (e)=>{
        for (const s of this.querySelectorAll('.sortby-collection button')){
          s.classList.remove('active');
        }
        btn.classList.add('active');
        window.location = queryStringUrlReplacement(window.location.href, 'sort_by', btn.getAttribute('data-perm'));
      });
    }
    
    this.querySelector('#second-drawer').querySelector('.back-clearfilter')
      .addEventListener('click', e=>{
        e.preventDefault();
        let tag = e.target.closest('#second-drawer').data_selected.selectedValue
        this.toggleSelectedTag(tag);
        this.navigateByTags();
      })

    this.querySelector('#right-drawer').querySelector('.clear-filters')
    .addEventListener('click', e=>{
      this.clearAllSelectedTags();
      this.navigateByTags();
    })
  } 

  loadData(){
    fetch(mobilemenu_data_json_path)
    .then(res => res.json())
    .then((out) => {
        metafields_filter.split(',').forEach(filter=>{
          let item = out.find(i=> i.name === filter.trim());
          if(typeof(item) != 'undefined'){
            this._filterData.push(item);
          }
        });

        this._filterData.forEach((item) =>{
          item["selectedValue"] = "";
          item["selectedText"] = "";
          item.options.forEach(option=> {
            if (this.selectedTags.indexOf(option.value.toLowerCase()) != -1) {
              item["selectedValue"] = option.value.toLowerCase();
              item["selectedText"] = option.display;
            }
          });
        });


        this.refreshRightDrawer();
        this._dataLoaded = true;
      }).catch(err => console.error(err));
  }

  closeAll(){
    for(var d of this.querySelectorAll('.drawer')){
      d.classList.remove("open");
    }
    document.querySelector('body').style.overflow = "visible";
  }
  toggleSelectedTag(tagValue){
    if(this.selectedTags.indexOf(tagValue.toLowerCase()) === -1){
      this.selectedTags.push(tagValue.trim().toLowerCase());
    }
    else{
      this.selectedTags = this.selectedTags.filter(function(item){return item != tagValue.toLowerCase() })
    }
  }
  clearAllSelectedTags(){
    this.selectedTags = [];
  }
  navigateByTags(){
    var tagSrt = this.selectedTags.filter(i=> i.length > 0).map(i=> i.trim().toLowerCase().replaceAll(" ", "-")).join(' ').trim().split(' ').join('+')
    navigateToTagPage(tagSrt);
  }
  openSecond = function(secndDrawerData){
    const innerItem = (cls, text)=> `<button class="${cls}">${text}</button>`;
    let secondDraw = this.querySelector('#second-drawer');
    secondDraw.data_selected = secndDrawerData;
    secondDraw.classList.add('open');
    secondDraw.querySelector('.filter-name').innerHTML = secndDrawerData.title;
    let ul = secondDraw.querySelector('ul');
    ul.innerHTML = '';
    secndDrawerData.options.filter(i=> i.value.length > 0).forEach(i=> {
      let li = document.createElement('li');
      let cnames = '';
      if(this.selectedTags.indexOf(i.value.toLowerCase()) > -1){
        cnames = "active"
      }
      li.innerHTML = innerItem(cnames, i.display);
      li.addEventListener('click', e=>{
        e.preventDefault();
        this.toggleSelectedTag(secndDrawerData.selectedValue);
        this.toggleSelectedTag(i.value);
        this.navigateByTags();
      });
      ul.appendChild(li);
    });
    setTimeout(function(){
      //secondDraw.querySelector(".drawer-Inner").height ="99.99%";
      //secondDraw.querySelector(".drawer-Inner").height = "100%";
    }, 300);
    secondDraw.querySelector('.drawer-header-text').addEventListener('click', e=>{
      e.preventDefault(); 
      secondDraw.classList.remove('open')
    });
  };

  refreshRightDrawer(){
    const innerContent  = (title,selectedText)=>`<button >
    ${title}
    <span class="filters_Icon">
      <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
      </path></svg>
    </span>
  </button>
  <span class="selected-value">${selectedText} &nbsp;</span>`;
    let ul = this.querySelector('.filterby-collection');
    ul.innerHTML = "";
    this._filterData.forEach((i)=>{
      let li = document.createElement('li');
      li.classList.add('filter-group');
      li.innerHTML = innerContent(i.title, i.selectedText);
      li.data_select_group = i;
      li.querySelector('button').addEventListener('click', (e)=>{
        e.preventDefault();
        this.openSecond(i);
      });
      ul.appendChild(li);
    });


  }
  
  openLeft(){
    this.closeAll();
    document.getElementById('left-drawer').classList.add('open');
    document.querySelector('body').style.overflow = "hidden";
  }
  openRight(){
    if(!this._dataLoaded){
      this.loadData();
      this.querySelector('#second-drawer').style.display="block";
      this.querySelector('#right-drawer').style.display="block";
    }
    this.closeAll();
    document.getElementById('right-drawer').classList.add('open');
    document.querySelector('body').style.overflow = "hidden";
  }
}
window.customElements.define('dyefor-collection-filter', DyeforCollectionFilter);


for (const link of document.querySelectorAll(".collection-hero__text-wrapper .toggle-description")) {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    let ele = event.target.closest('.collection-hero__text-wrapper');
    (ele.classList.contains('open')) ? 
    ele.classList.remove('open')
    :
    ele.classList.add('open');
  })
}

if(document.querySelector('.collection-accordion-wrapper.showp-by-device .collection-accordion__header')){
  document.querySelector('.collection-accordion-wrapper.showp-by-device .collection-accordion__header').addEventListener('click', (e)=>{
    e.preventDefault();
    const openClasName = 'open';
    let target = e.currentTarget;
    (target.classList.contains(openClasName))? target.classList.remove(openClasName): target.classList.add(openClasName)
  });
}
function isElementOverflowing(element){
  if(element){
    return (element.offsetHeight < element.scrollHeight) || (element.offsetWidth < element.scrollWidth) 
  }
  
  return false;
}
if(!isElementOverflowing(document.querySelector('.collection-hero__text-wrapper .collection-hero__description'))){
  try{
    document.querySelector('.collection-hero__text-wrapper .read-more').style.display = "none";
    document.querySelector('.collection-hero__text-wrapper .read-less').style.display = "none";
  }
  catch{}
} 


for (const link of document.querySelectorAll('.collection-accordion-wrapper .collection-accordion__header.accordion__header')){
  link.addEventListener('click', function(event) {
    event.preventDefault();
    let target = event.target;
    if(!target.classList.contains('collection-accordion__header')){
      target = target.closest('.collection-accordion__header');
      if(!target){
        return;
      }
    }
    let nextSibling = target.nextElementSibling;
    if((!nextSibling.style.display) || nextSibling.style.display == "none"){
      nextSibling.style.display = "block";
    }else{
      nextSibling.style.display = "none";
    }
  });
}



function removeParam(sourceURL, key) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1);
          }
      }
      rtn = rtn + "?" + params_arr.join("&");
  }
  
  if(rtn.charAt(rtn.length-1) === '?'){
    return rtn.substring(0, rtn.length - 1);
  }
  
  return rtn;
}
function queryStringUrlReplacement(url, param, value) 
  {
    if(!value || value.length === 0){
      return removeParam(url, param);
    }
    
    var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;

    if (match === null) {
        // append new param
        var hasQuestionMark = /\?/.test(url); 
        delimiter = hasQuestionMark ? "&" : "?";
        newString = url + delimiter + param + "=" + value;
    } else {
        delimiter = match[0].charAt(0);
        newString = url.replace(re, delimiter + param + "=" + value);
    }

    return newString;
  }
function productTopMessageOverlay(){
  for(const card of document.querySelectorAll('.card__inner')){
    let colour = card.getAttribute('data-top-overlay-message-colour');
    let message = card.getAttribute('data-top-overlay-message');
    if(!message){
      continue;
    }
    if(!colour){
      colour = '#000';
    }

    let messageDiv = document.createElement('div');
    messageDiv.classList.add('top-message-overlay');
    messageDiv.style.backgroundColor = colour;
    messageDiv.innerText = message;
    let media = card.querySelector('.card__media');
    media?.appendChild(messageDiv);
  }
}
setTimeout(productTopMessageOverlay(), 300);